import React, { FunctionComponent, Fragment } from "react";
import BreadcrumbLinkProps from "./BreadcrumbLinkProps.interface";
import styles from "./BreadcrumbLink.module.scss";
import Anchor from "components/Anchor/Anchor";
import IconViewer from "components/IconViewer/IconViewer";

const BreadcrumbLink: FunctionComponent<BreadcrumbLinkProps> = (props) => {
    return (
        <Fragment>
            {
                !props.isLast ? (
                    <Anchor to={props._url} className={styles.breadcrumb_link}>
                        {props._name}
                    </Anchor>
                ) : (
                    <span className={styles.breadcrumb_span}>{props._name}</span>
                )
            }

            <IconViewer className={styles.chevron_right} name="chevron-right"/>
        </Fragment>
    );
};

export default BreadcrumbLink;
